<style lang="scss">
.app-wrapper {
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<template>
  <div :class="className" class="app-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
